<template>
  <div class="s3-upload-progress elevation-2 pa-1 my-2" v-show="isCurrentUpload || isQueued">
    <v-input :label="statusString">
      <template>
        <v-progress-linear
          class="mt-1"
          v-model="uploadProgress"
          :title="uploadProgressString"
          :color="barColor"
          :indeterminate="isQueued"
          ></v-progress-linear>
      </template>

      <template v-slot:append>
        <v-icon class="mt-2" @click="stopUpload()">close</v-icon>
      </template>
    </v-input>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
	props: ["dataId", "fieldName", "fieldValue"],

	computed: {
    uploads () { return this.$store.state.s3uploader.uploads },
    currentUpload () { return this.$store.state.s3uploader.currentUpload },
    uploadProgressString () { return this.$store.state.s3uploader.uploadProgress },
    uploadProgress () { return parseInt(this.uploadProgressString, 10) },

    isQueued () {
      if ( typeof(this.uploads) == "undefined" || this.uploads.length == 0 ) { return false }

      let matchFound = false
      this.uploads.forEach((upload) => {
        if (matchFound) { return }

        // Check for same field name different items with list data id
        if (this.dataId == upload.dataId && this.fieldName == upload.fieldName) {
          matchFound = true
        }
      })

      return matchFound
    },
    isCurrentUpload () {
      if ( typeof(this.currentUpload) == "undefined" || this.currentUpload == null ) { return false }

      // Check for same field name different items with list data id
      if (this.dataId != this.currentUpload.dataId) { return false }

      return this.fieldName == this.currentUpload.fieldName
    },

    barColor () { return this.isCurrentUpload ? "success" : "info"},
    statusString () {
      if (this.isCurrentUpload) { return "Uploading: " + this.uploadProgressString }
      return "Uploading: queued"
    },
  },

	methods: {
    stopUpload() {
      // Abort current upload or remove queued upload item
      if (this.isCurrentUpload) {
        this.$store.dispatch('s3uploader/cancelCurrentUpload')
      }

      if (this.isQueued) {
        this.$store.dispatch(
          's3uploader/removeQueuedUpload',
          { dataId: this.dataId, fieldName: this.fieldName }
        )
      }

      return true
    }
	}
}
</script>
<style scoped>
</style>
